/** Jeff Hiser demo scheduling link for organizational sales. */
export const CALENDLY_DEMO_URL =
  'https://calendly.com/jeff-polarisathlete/polaris-athlete-hub-demo';
